import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms"
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router"
import { AuthService } from "../../../_common/_service/authservice.service";
import { TokenStorageService } from "../../../_common/_service/token-storage.service";
import { ForgetPasswordComponent } from "../forget-password/forget-password.component";
import { ToastrService } from 'ngx-toastr';
import { async, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { CommonService } from "../../../_common/_service/user.service";
import { AuthenticationService } from "../../../_common/_service/authentication.service";
import { EncrDecrService } from "../../../_common/_service/EncrDecrService.service";
import { OpenchangepasswordComponent } from "../../popup/openchangepassword/openchangepassword.component";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  submitted = false;
  
  loadingspinner: boolean = false;
  isLoggedIn = false;

  errorMessage = '';
  roles: string[] = [];
  loginForm: FormGroup;
  ServiceCountryList: any;
  ServiceList: any;
  loginuserdetails: any;
 
  _refresh = new BehaviorSubject<boolean>(true);
  currentuser: any;
  decrypted: any;
  response: any;

  constructor(private fb: FormBuilder, public dialog: MatDialog, private authService: AuthService, private tokenStorage: TokenStorageService,
    private toastr: ToastrService, private router: Router, public dialogRef: MatDialogRef<LoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _service: AuthenticationService, private EncrDecr: EncrDecrService
  ) {
    this.loginForm = this.fb.group({
      userName: [null, [Validators.required]],      
      password: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      //serviceId: [null, [Validators.required]]
      userDeviceType: 0,
      userDeviceToken: null
    });



  }


  ngOnInit() {
  
    //this.getServiceCountryList();    
  }
  
  get fl() { return this.loginForm.controls; }

  public redirectUrl: string = '';

  login(post: any) {
    
    this.submitted = true;

    if (this.loginForm.valid) {
      this.loadingspinner = true;
      debugger;

      this.authService.login1(post).subscribe((x1: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
        debugger;

        this.loadingspinner = false;
        console.log(x1.apiMessage);

        if (x1.apiStatus == false && x1.apiMessage == "Change Password") {
          this.openModal1();
        }

        else if (x1.apiStatus == false ) {
          this.toastr.error(x1.apiMessage, 'Error');
        }

        else {
          
          var response = {

            firstname: x1.apiData.FirstName,
            lastname : x1.apiData.lastName,

            fullusername: x1.apiData.FirstName + ' ' + x1.apiData.lastName,
            MobileNo: x1.apiData.Mobileno,

            mobileotpstatus: x1.apiData.mobilenostatus,
            emailConfirmed : x1.apiData.emailidstatus,
            userName: x1.apiData.emailid,
            email: x1.apiData.emailid,
            userid: x1.apiData.userid
          };

     
          
          this.tokenStorage.saveUser(response);

          this.tokenStorage.updateMessage1(this.tokenStorage.getUser());
          this.tokenStorage.saveToken(x1.apiData.token);


          this.toastr.success(x1.apiMessage, 'Success');
          
          this.router.navigate(['/Go-on']);
          
          this.dialogRef.close();
        }
      },
        (err: any) => {
          debugger;
          this.loadingspinner = false;
          if (err.error instanceof Error) {

            this.toastr.error(err.error, 'Error');
          } else {

            this.toastr.error(err.error, 'Error');
          }
        }
      );

    }



    //if (this.loginForm.valid) {

    //  

    //  //Using switchMap

    //  this.authService.login1(post).pipe(
    //    switchMap((x: { apiStatus: boolean; apiData: any; }) => {
    //      
    //      if (x.apiStatus != false) {
    //        this.loginuserdetails = x;
    //        ////////console.log(x);

    //        this.token = x.apiData.token;
    //        this.tokenStorage.saveToken(this.token);
    //        return this.authService.getValidateeziPaycountryToken();
    //      } else {

    //        //this.toastr.error(x.apiMessage, 'Error');
    //        return of(x);
    //      }


    //    })
    //  ).subscribe((x1: { apiStatus: boolean; apiMessage: string | undefined; }) => {
    //    
    //    if (x1.apiStatus == false) {
    //      this.toastr.error(x1.apiMessage, 'Error');
    //    }
    //    else {
    //      
    //      // this.ServiceList = x1;

    //      this.getList(x1);
    //      

    //      this.dialogRef.close();

    //    }

    //  },
    //    (err: { error: string | undefined; }) => {
    //      this.toastr.error(err.error, 'Error');
    //    }
    //  );

    //}
  }

  //getValidateeziPaycountryToken() {

  //  this.authService.getValidateeziPaycountryToken().subscribe(
  //    (response: { isSuccess: any; result: any; }) => {
  //      
  //      this.ServiceList = response; //
  //    }, (err: any) => {
  //      this.toastr.error(err.error, 'Error');
  //    });
  //}

  getServiceCountryList() {
    
    this.submitted = true;

    this.authService.getServiceCountryList().subscribe(
      (response: { isSuccess: any; result: any; }) => {
        ;
        this.ServiceCountryList = response;
        //var d = this.ServiceCountryList.filter((x: { serviceId: any; }) => x.serviceId == 7);

        ;
        //this.ServiceCountryList = d;
      }, (err: any) => {
        this.toastr.error(err.error, 'Error');
      });
  }

  //getList(val1: any) {
  //  //  this._service.check(val1);
  //  //}
  //  this.authService.getList().subscribe(
  //    response => {
  //      

  //      response.serviceProvider1 = val1.apiData.serviceProvider;

  //      response.firstname = response._Userinfo.firstName;
  //      response.lastname = response._Userinfo.lastName;
  //      response.fullusername = response._Userinfo.firstName + ' ' + response._Userinfo.lastName;
  //      response.MobileNo = response._Userinfo.mobileNo;
  //      response.IsdCode = response._Userinfo.isdCode;
  //      response.mobileotpstatus = response.phoneNumberConfirmed == "True" ? 1 : 0;
  //      response.emailConfirmed = response.emailConfirmed == "True" ? 1 : 0;
  //      response.profileImage = response._Userinfo.profileImage;

  //      this.tokenStorage.saveUser(response);

  //      

  //      //if (val != 1) {
  //      this.toastr.success(val1.apiMessage, 'Success');

  //     // this.tokenStorage.isUserLoggedIn.next(true);
  //      this.router.navigate(['/Go-on']);
  //      //}
  //    }, (err: any) => {
  //      this.toastr.error(err.error, 'Error');
  //    });
  //}

  openModal() {
    const dialogRef = this.dialog.open(ForgetPasswordComponent, {
      data: null
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModal1() {
    const dialogRef = this.dialog.open(OpenchangepasswordComponent, {
      data: null
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

}
